import React from 'react';
import DeshOrder from '../../DashboardExtra/DeshOrder/DeshOrder';

const Dashboard = () => {
    return (
        <div style={{padding:'0 2%'}}>
            <h1 style={{textAlign:'center',fontSize:'25px',borderBottom:'2px solid',textTransform:'capitalize'}}>admin dashboard</h1>
            <DeshOrder></DeshOrder>
        </div>
    );
};

export default Dashboard;